import {
  ApiKeyPermission,
  ICreateApiKeyBody,
  ICreateApiKeyResponse,
  IUserApiKey,
} from 'src/api/types/apiKey'
import { ISuccess } from 'src/api/types/success'

import { client } from '../axios'
import { ApiRoutes } from '../routes'
import { IUserResponse } from '../types/user'

interface IPostUserBody {
  email: string
  password: string
  name: string
}

interface IPatchStartRestoration {
  email: string
}

interface IPatchFinishRestoration {
  password: string
  restorationCode: string | undefined
}

interface IPatchChangePassword {
  currentPassword: string
  newPassword: string
  passwordConfirmation: string
}

interface IPatchUpdateUserName {
  name: string
}

export const postUser = async (body: IPostUserBody): Promise<ISuccess> => {
  return (await client.post(ApiRoutes.postUser, body)).data
}

export const patchStartRestoration = async (
  body: IPatchStartRestoration,
): Promise<ISuccess> => {
  return (await client.patch(ApiRoutes.patchStartRestoration, body)).data
}

export const patchFinishRestoration = async (
  body: IPatchFinishRestoration,
): Promise<ISuccess> => {
  return (await client.patch(ApiRoutes.patchFinishRestoration, body)).data
}

export const patchChangePassword = async (
  body: IPatchChangePassword,
): Promise<ISuccess> => {
  return (await client.patch(ApiRoutes.patchChangePassword, body)).data
}

export const patchUpdateUserName = async (
  body: IPatchUpdateUserName,
): Promise<ISuccess> => {
  return (await client.patch(ApiRoutes.patchUpdateUserName, body)).data
}

interface IWhoAmIResponse {
  user: IUserResponse
}

export const getWhoAmI = async (): Promise<IWhoAmIResponse> => {
  return (await client.get(ApiRoutes.getWhoAmI)).data
}

export const postUserReport = async (body: any): Promise<ISuccess> => {
  return (await client.post(ApiRoutes.postUserReport, body)).data
}

export const getUserApiKeys = async (): Promise<{ apiKeys: IUserApiKey[] }> => {
  return (await client.get(ApiRoutes.userApiKeys)).data
}

export const postUserApiKey = async (
  body: ICreateApiKeyBody,
): Promise<ICreateApiKeyResponse> => {
  return (await client.post(ApiRoutes.userApiKeys, body)).data
}

export const patchUserApiKey = async (
  id: number,
  body: { name?: string; permissions?: ApiKeyPermission[] },
): Promise<IUserApiKey> => {
  return (await client.patch(ApiRoutes.userApiKey(id), body)).data
}

export const deleteUserApiKey = async (id: number): Promise<ISuccess> => {
  return (await client.delete(ApiRoutes.userApiKey(id))).data
}
